import { cn } from "@/common/helpers/utils";
import { Card } from "@/components/ui/card";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import type { ReactNode } from "react";

interface SelectionCardProps {
  label: string;
  icon?: ReactNode;
  isSelected: boolean;
  disabled?: boolean;
  disabledReason?: string;
  onClick: () => void;
}

export function SelectionCard({ label, icon, isSelected, disabled, disabledReason, onClick }: SelectionCardProps) {
  const card = (
    <Card
      className={cn(
        "items-center gap-3 rounded-lg p-10 transition-colors",
        disabled
          ? "cursor-not-allowed opacity-50"
          : isSelected
            ? "border-primary/30 bg-primary/10 dark:border-primary/30 dark:bg-primary/10"
            : "hover:bg-primary/20 hover:border-primary/60 hover:dark:bg-primary/20 hover:dark:border-primary/60 cursor-pointer",
      )}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      aria-pressed={isSelected}
      onClick={disabled ? undefined : onClick}
      onKeyDown={(e) => {
        if (!disabled && (e.key === "Enter" || e.key === " ")) onClick();
      }}
    >
      {icon}
      {label}
    </Card>
  );

  if (disabled && disabledReason) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>{card}</TooltipTrigger>
          <TooltipContent>{disabledReason}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return card;
}
